var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts-box"},[_c('el-card',{staticClass:"box-card"},[_c('div',{ref:"demo",staticClass:"chart",style:({ height: _vm.height }),attrs:{"id":_vm.echartsData.id}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }